import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { checkIfElementExists } from "../helper/dom-helper";
import { ensureSwiperIsReadyForLooping } from "../helper/swiper-helper";
import 'swiper/css';

export async function initializeHomePageSlider() {
    const homePageSliderQuerySelector = '.home-page-carousel';

    if (! await checkIfElementExists(homePageSliderQuerySelector)) {
        // We are probably on another page, just don't do anything

        return;
    }

    new Swiper(homePageSliderQuerySelector, {
        modules: [Navigation, Autoplay],
        loop: true,
        speed: 800,
        autoplay: {
            delay: 8000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: `${homePageSliderQuerySelector} > .swiper-button-next`,
            prevEl: `${homePageSliderQuerySelector} > .swiper-button-prev`,
        },
        rtl: true,
        breakpoints: {
            0: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 50,
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 10,
            },
        },
        on: {
            init: (swiper) => {
                swiper.el.classList.add('swiper-initialized');
            },
            beforeInit: (swiper) => {
                ensureSwiperIsReadyForLooping(swiper);
            }
        },
    });
}

export async function initializeHomePagePopularBrandsSlider() {
    const popularBrandsSliderQuerySelector = '.home-popular-brands-carousel';

    if (!await checkIfElementExists(popularBrandsSliderQuerySelector)) {
        // We are probably on another page, just don't do anything

        return;
    }

    new Swiper(popularBrandsSliderQuerySelector, {
        modules: [Navigation],
        loop: true,
        speed: 300,
        navigation: {
            nextEl: `${popularBrandsSliderQuerySelector} > .swiper-button-next`,
            prevEl: `${popularBrandsSliderQuerySelector} > .swiper-button-prev`,
        },
        slidesPerView: 3,
        spaceBetween: 10,
        breakpoints: {
            0: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            600: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            1000: {
                slidesPerView: 6,
                spaceBetween: 35,
            },
        },
        on: {
            init: (swiper) => {
                swiper.el.classList.add('swiper-initialized');
            },
        },
    });
}
